/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFrame = createReactComponent("outline", "frame", "IconFrame", [["path", { "d": "M4 7l16 0", "key": "svg-0" }], ["path", { "d": "M4 17l16 0", "key": "svg-1" }], ["path", { "d": "M7 4l0 16", "key": "svg-2" }], ["path", { "d": "M17 4l0 16", "key": "svg-3" }]]);

export { IconFrame as default };
//# sourceMappingURL=IconFrame.mjs.map
